module.exports = __webpack_public_path__ + "img/16-TelmexConnect.81bda8e6.jpg";